import { render } from "./ShareSite.vue?vue&type=template&id=3bd3db85"
import script from "./ShareSite.vue?vue&type=script&lang=js"
export * from "./ShareSite.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__